import React, { useEffect } from "react";
import { Form, Input, Modal, Checkbox } from "antd";
import { getPermissionOptions } from "../../utils/permission";

const accountValidator = (_, value) => {
  const v = String(value || "").trim();
  if (!v) {
    return Promise.reject(new Error("请输入已注册的360账号"));
  }

  if (v.length > 128) {
    return Promise.reject(new Error("账号长度不能超过128个字符"));
  }

  if (v.includes("@")) {
    if (!/^[\w.+-]+@[\w-]+(\.[\w-]+)+$/.test(v)) {
      return Promise.reject(new Error("邮箱格式不正确"));
    }
  } else if (/^\d+$/.test(v)) {
    if (v.length < 5 || v.length > 11) {
      return Promise.reject(new Error("手机号/QID格式不正确"));
    }
  }

  return Promise.resolve();
};

const nicknameValidator = (_, value) => {
  const v = String(value || "").trim();

  if (v.length > 20) {
    return Promise.reject(new Error("备注名不能超过20个字符"));
  }

  return Promise.resolve();
};

const SubAccountFormModal = ({
  open,
  mode = "add",
  loading = false,
  initialValues,
  permissionModules = [],
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        account: initialValues?.account || initialValues?.qid || initialValues?.qidMasked || "",
        nickname: initialValues?.nickname || "",
        permissions: initialValues?.permissions || [],
      });
    } else {
      form.resetFields();
    }
  }, [form, initialValues, open]);

  const handleOk = async () => {
    const values = await form.validateFields();
    onSubmit?.({
      ...values,
      account: values.account ? String(values.account).trim() : "",
      nickname: values.nickname ? String(values.nickname).trim() : "",
      permissions: values.permissions || [],
    });
  };

  return (
    <Modal
      title={mode === "edit" ? "编辑权限" : "添加子账号"}
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="360账号"
          name="account"
          rules={[{ validator: accountValidator }]}
          extra="支持输入360账号、手机号、邮箱或qid，由后端统一解析。"
        >
          <Input placeholder="请输入360账号/手机号/邮箱/qid" disabled={mode === "edit"} />
        </Form.Item>
        <Form.Item
          label="备注名"
          name="nickname"
          rules={[{ validator: nicknameValidator }]}
        >
          <Input placeholder="请输入备注名" />
        </Form.Item>
        <Form.Item label="权限模块" name="permissions">
          <Checkbox.Group options={getPermissionOptions(permissionModules, { scope: "sub_account" })} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SubAccountFormModal;
